import { tsValidateArray, tsValidateRegexp, tsValidateString } from '@nu-art/ts-common';
import { knowledgeManagerDBGroup } from '@app/hcs-shared';
const validateColorValue = tsValidateRegexp(/^#([0-9A-Fa-f]{3,4}){1,2}$/);
const Validator_ModifiableProps = {
    label: tsValidateString(),
    colors: tsValidateArray(validateColorValue),
};
const Validator_GeneratedProps = {};
export const DBDef_ColorGroup = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.1', '1.0.0'],
    dbKey: 'color-groups',
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'color-group'
    },
    backend: {
        name: 'color-groups'
    },
    entityName: 'ColorGroup',
};
//# sourceMappingURL=db-def.js.map